import { useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useCatalogService } from '../services/catalogService';
import { rowConfigFor, ATTENTION_STATES } from '../rowConfig';

export const deploymentKeys = {
  list: (customerId: string | undefined) => ['service-administration', 'deployments', customerId] as const,
};

export function useDeploymentList(customerId: string | undefined) {
  const catalogService = useCatalogService();

  const query = useQuery({
    queryKey: deploymentKeys.list(customerId),
    queryFn: async () => {
      const result = await catalogService.listDeployments(customerId as string);
      return result.deployments;
    },
    enabled: !!customerId,
  });

  const deployments = query.data ?? [];
  const attentionItems = deployments.filter(
    (d) => ATTENTION_STATES.includes(rowConfigFor(d, undefined, undefined).state),
  );

  const { refetch } = query;
  const refresh = useCallback(async () => {
    await refetch();
  }, [refetch]);

  return {
    deployments,
    attentionItems,
    loading: query.isFetching,
    error: query.error
      ? query.error instanceof Error
        ? query.error.message
        : 'Failed to load deployments'
      : null,
    refresh,
  };
}
